import { definitions } from "../../../../../supabase-types";
import ButtonPrimary from "../../../Common/Buttons/ButtonPrimary";
import BaseCard from "../../../Common/Cards/BaseCard";
import Input from "../../../Common/Forms/Input";
import Select from "../../../Common/Forms/Select";
interface CreateClassDialogProps {
  levels: definitions["Level"][];
  setNewClass: Function;
  newClass: {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    levelId?: number | undefined;
  };
  handleCreateClass: () => void;
}

export function CreateClassDialog(props: CreateClassDialogProps) {
  return (
    <BaseCard title="Create Class">
      <div className="w-full inline-flex flex-col gap-3">
        <Select
          icon="badge"
          placeholder="Choose Level"
          options={
            props.levels
              ? props.levels.map((level) => ({
                  value: level.id,
                  label: `${level.name} HSK Difficulty: ${level.hskDifficulty}`,
                }))
              : []
          }
          onChange={(val) =>
            props.setNewClass({ ...props.newClass, levelId: +val })
          }
        />
        {/* TODO: Set start date and end date labels @stephen */}
        <Input
          type="date"
          placeholder="Start Date"
          icon="calendar"
          onChange={(val) =>
            props.setNewClass({ ...props.newClass, startDate: new Date(val) })
          }
        />
        <Input
          type="date"
          placeholder="End Date"
          icon="calendar"
          onChange={(val) =>
            props.setNewClass({ ...props.newClass, endDate: new Date(val) })
          }
        />
      </div>
      <ButtonPrimary onClick={props.handleCreateClass}>Create</ButtonPrimary>
    </BaseCard>
  );
}
